<template>
	<ui-modal title="Excluir usuário" name="users-remove-user-modal" icon="fal fa-trash-alt" size="xs">
		<div class="modal-content-line">
			<p>
				Selecione um <span class="color-primary">{{labelComputed}}</span> para receber os dados do usuário(a)
				<span class="color-primary">{{nameComputed}}</span>.
			</p>
			<p>
				O usuário selecionado passará a fazer parte das listas de distribuição de leads e oferta ativa, caso o
				usuário(a) <strong>{{nameComputed}}</strong> faça parte de alguma dessas filas.
			</p>
		</div>

		<form class="modal-content-line form">
			<ui-select-2
				v-show="showDynamics"
				v-model="dynamic"
				:data="dynamics"
				:multiple="false"
				:loading="loader.dynamic"
				item-label="label"
				label="Grupo dinâmico:"
				return-label="label"
				size="md"

				@input="dynamicHandler($event)"
			/>

			<ui-select-2
				v-model="admin"
				:data="admins"
				:multiple="false"
				:label="labelComputed"
				:loading="loader.admin"
				size="md"
				item-label="first_name"
				return-label="id"
				search-event="admin"
				ajax-search
				@input="disableSubmitHandler()"
			/>
		</form>

		<div class="modal-content-line alert">
			<strong>Atenção</strong>
			<div>Ao confirmar a exclusão do usuário esta ação não poderá ser desfeita.</div>
		</div>

		<template #footer>
			<ui-button design="md link" @click="close">Cancelar</ui-button>
			<ui-button design="md danger" @click="confirm" :disabled="layout.isDisableSubmit">
				Confirmar Exclusão
			</ui-button>
		</template>
	</ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiSelect2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'

	import { user } from '@/services/axios'
	import { storage } from "@/services/storage"

	import { alertMixin } from '@/mixins'

	import axios from 'axios'

	const defaultLayout = () => {
		return {
			isDisableSubmit: true,
		}
	}

	const defaultLoader = () => {
		return {
			admin: false,
			dynamic: false,
		}
	}

	const defaultAdminSearchParams = (search, group, page) => {
		return {
			group,
			q: search,
			page,
			perPage: 15,
		}
	}

	export default {
		components: {
			uiModal,
			uiSelect2,
			uiButton,
		},

		mixins: [alertMixin],

		data() {
			return {
				admin: null,
				admins: [],
				pagination: {
					page: 1,
					total_pages: 1
				},
				cancel_token: null,
				names: {
                    admin: storage.get('label_admin'),
                    collaborator: storage.get('label_collaborator')
				},
				dynamic: null,
				dynamics: [],
				showDynamics: false,
				user: {
					group_name: 'admin'
				},
				layout: { ...defaultLayout() },
				loader: { ...defaultLoader() }
			}
		},

		mounted() {
			/**
			 * Ao abrir o modal recebe os dados do usuário a ser bloqueado
			 */
			this.$root.$on('modal-open-users-remove-user-modal', async (data) => {
				this.user = data
				this.resetLayout()
				this.resetLoader()

				this.admins = []
				this.dynamics = []
				this.showDynamics = false

				if (['admin', 'collaborator'].includes(this.user.group_name)) {
					await this.loadAdmin(this.user.group_name, '', this.pagination.page)

				} else {
					this.showDynamics = true
					await this.loadDynamic()
				}
			})

			/**
			 * Trata o evento de quando o scroll do select de admins é utilizado
			 */
			this.$root.$on('select2-ajax-search-admin', async (data) => {
				if (!data.nextPage) {
					this.$set(this.pagination, 'page', 1)
					this.$set(this.pagination, 'total_pages', 1)
					this.admin = null
					this.admins = []

				} else {
					if (this.pagination.page < this.pagination.total_pages) {
						this.$set(this.pagination, 'page', this.pagination.page + 1)

					} else {
						return
					}
				}

				if (this.cancelToken) this.cancelToken.cancel()
				this.cancelToken = axios.CancelToken.source()
				await this.loadAdmin(this.dynamic
						? this.dynamic.label
						: this.user.group_name,
					data.search,
					this.pagination.page
				)
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-users-remove-user-modal')
			this.$root.$off('select2-ajax-search-admin')
		},

		computed: {
			labelComputed(){
				if (['admin', 'collaborator'].includes(this.user.group_name)){
					return this.names[this.user.group_name]
				}else{ 
					return this.dynamic ? this.dynamic.label : this.user.group_name
				}
			},


			nameComputed() {
				let name = this.user.first_name || '' + ' ' + this.user.last_name || ''
				return name.trim()
			},

			adminComputed: {
				get() {
					return this.admins
				},

				set(value) {
					this.admin = value
					if (value.trim()) {
						this.$set(this.layout, 'isDisableSubmit', false)
					} else {
						this.$set(this.layout, 'isDisableSubmit', true)
					}
				},
			},
		},

		methods: {
			/**
			 * Reseta o layout
			 */
			resetLayout() {
				this.layout = {
					...defaultLayout(),
				}
			},

			/**
			 * Reseta os loadings
			 */
			resetLoader() {
				this.loader = {
					...defaultLoader(),
				}
			},

			close() {
				this.$root.$emit('modal-close-users-remove-user-modal')
			},

			/**
			 * Executado quando se confirma a exclusão do usuário
			 */
			confirm() {
				let formData = {
					newTeam: null,
					newManager: null,
					newUser: this.admin.id
				}

				user
					.destroy('', this.user.id, formData)
					.then(response => {
						if (response.data && response.data.status !== 'error') {
							this.$root.$emit('users-search')
							this.close()
						}else { 
							this.$toastr.e(response.data.msg)
						}
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
			},
			/**
			 * Carrega os grupos dinâmicos disponiveis
			 */
			async loadDynamic(){
				this.$set(this.loader, 'dynamic', true)

				try {
					const { data } = await user.groups()

					this.dynamics = data.map(e => {
						return {
							id: e.id,
							label: e.name,
						}
					})
				} catch (error) {
					this.$mx_alertError(error)
				} finally {
					this.$set(this.loader, 'dynamic', false)
				}
			},

			/**
			 * Carrega os dados dos Administradores de acordo com o ID do usuário
			 */
			async loadAdmin(group, search, page) {
				this.admins = []
				if (!group) return

				this.$set(this.loader, 'admin', true)
				try {
					const params = { ...defaultAdminSearchParams(search, group, page) }
					const { data } = await user.getAll('search', params)

					if (data.data.status === 'error') throw data.data.msg

					this.admins = data.data.filter(item => { if (this.user.id !== item.id) return item })

				} catch (error) {
					this.$mx_alertError(error)

				} finally {
					this.$set(this.loader, 'admin', false)
				}
			},

			/**
			 * Carrega os usuarios dinamicamente baseado no grupo selecionado
			 */
			dynamicHandler(value){
				this.$set(this.pagination, 'page', 1)
				if (value) this.loadAdmin(value.label, '', this.pagination.page)
			},

			/**
			 * Habilita ou não o botao baseado no valor
			 */
			disableSubmitHandler(){
				this.layout.isDisableSubmit = false

				if (this.admins.id) this.layout.isDisableSubmit = true
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
